if (process.env.NODE_ENV !== "production") {
  const VConsole = require("vconsole");
  new VConsole();
}
